import { useIntl } from 'react-intl';
import { Box } from '@mui/material';

import { SliderField, SliderFieldProps } from '../../Fields/SliderField/SliderField';
import { sliderTooltipMessages } from '../survey.messages';
import { UnitOfMeasure } from '../../../graphql/types.generated';
import { SizingMultiplier } from '../../../theme/constants';

export interface ISliderControlProps {
  min: number;
  max: number;
  name: string;
  measurement: UnitOfMeasure;
  onChange?: SliderFieldProps['onChange'];
}

export const SliderControl = ({ min, max, name, measurement, onChange }: ISliderControlProps) => {
  const intl = useIntl();

  return (
    <Box sx={{ pt: SizingMultiplier.lg }}>
      <SliderField
        valueLabelDisplay="on"
        valueLabelFormat={(value: number) => intl.formatMessage(sliderTooltipMessages[measurement], { value })}
        name={name}
        min={min}
        max={max}
        onChange={onChange}
      />
    </Box>
  );
};
